import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Empty, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const NotFoundWithBack = ({ description }: { readonly description: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Flex align="center" gap="middle" vertical>
      <Empty description={description} />
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
        {t("common.back")}
      </Button>
    </Flex>
  );
};
